import type {Bot} from '../bot-loaders';

interface GTAG {
    gtag(type:string, eventName:string, eventParameters:any):void;
}

interface AccountEvent {
    type: "account_event",
    params: {
        account_action: "login" | "create_audience",
        account_name: string
    } 
}

export type AudienceEvent = "update_audience" | "create_file" | "create_audience"; 

interface BotEvent {
    type: "bot_event",
    params: {
        bot_action: "start" | "stop" | "logout" | "reset" | AudienceEvent
        bot_name: string
        campaign_name?: string
    } 
}

type BotAction = BotEvent['params']['bot_action'];


export function logEvent(event: BotEvent | AccountEvent ){
    const logger = (window as any) as GTAG;
    if(!logger.gtag)
        return;
    logger.gtag("event", event.type, event.params)
}

export function logBotEvent(bot: Bot, event: BotAction, campaign_name: string = null){
    logEvent({type: 'bot_event', params: {bot_action: event, bot_name: bot.name, campaign_name}})
}

